export default () => ({
  replyOpen: false,
  replyText: '',
  openReply: function () {
    this.replyOpen = true;
    this.$nextTick(() => {
      this.$refs.inputBox.focus();
    });
  },
  cancelReply: function () {
    this.replyOpen = false;
    this.replyText = '';
  },
  replyDisabled: function () {
    return this.replyText.trim() === '';
  },
});
